export default "__VITE_ASSET__DTIaU0qb__"